import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const DownloadService = {
    list: async (payload) => axios.post(API_URL + "/download/list", payload).then(({ data }) => data).catch((err) => { throw err}),

    types: async () => axios.get(API_URL + "/download/types").then(({ data }) => data).catch((err) => { throw err}),

    download: (key, name) => API_URL + `/private/downloads/${key}/${name}`,

    downloadApp: () => API_URL + "/repo/sentry-instalador.jar", 
}

export default DownloadService;